import uniAdminApi from "./api";

const eventService = {
  getEvents: async (filters = {}) => {
    const res = await uniAdminApi.get("/university-admin/events", { params: filters });
    return res.data;
  },

  getEvent: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/events/${id}`);
    return res.data;
  },

  createEvent: async (data) => {
    const res = await uniAdminApi.post("/university-admin/events", data);
    return res.data;
  },

  updateEvent: async (id, data) => {
    const res = await uniAdminApi.put(`/university-admin/events/${id}`, data);
    return res.data;
  },

  cancelEvent: async (id) => {
    const res = await uniAdminApi.post(`/university-admin/events/${id}/cancel`);
    return res.data;
  },

  deleteEvent: async (id) => {
    const res = await uniAdminApi.delete(`/university-admin/events/${id}`);
    return res.data;
  },

  approveEvent: async (id) => {
    const res = await uniAdminApi.post(`/university-admin/events/${id}/approve`);
    return res.data;
  },

  rejectEvent: async (id, rejectionMessage) => {
    const res = await uniAdminApi.post(`/university-admin/events/${id}/reject`, { rejectionMessage });
    return res.data;
  },

  getTicketAttendants: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/events/${id}/ticket-attendants`);
    return res.data;
  },

  addTicketAttendants: async (id, emails) => {
    const res = await uniAdminApi.post(`/university-admin/events/${id}/ticket-attendants`, { emails });
    return res.data;
  },

  removeTicketAttendant: async (id, email) => {
    const res = await uniAdminApi.delete(`/university-admin/events/${id}/ticket-attendants`, { params: { email } });
    return res.data;
  },

  getEventStatistics: async (id) => {
    const res = await uniAdminApi.get(`/university-admin/events/${id}/statistics`);
    return res.data;
  },

  exportEventStatistics: async (id) => {
    return await uniAdminApi.get(`/university-admin/events/${id}/statistics/export`, { responseType: "blob" });
  },

  getEventParticipants: async (id, page = 0, size = 20) => {
    const res = await uniAdminApi.get(`/university-admin/events/${id}/participants`, { params: { page, size } });
    return res.data;
  },

  exportEventParticipants: async (id, format) => {
    return await uniAdminApi.get(`/university-admin/events/${id}/participants/export`, { params: { format }, responseType: "blob" });
  },

  getEventTicketOwners: async (id, page = 0, size = 20) => {
    const res = await uniAdminApi.get(`/university-admin/events/${id}/ticket-owners`, { params: { page, size } });
    return res.data;
  },

  exportEventTicketOwners: async (id, format) => {
    return await uniAdminApi.get(`/university-admin/events/${id}/ticket-owners/export`, { params: { format }, responseType: "blob" });
  },
};

export default eventService;
